module.exports = __webpack_public_path__ + "img/url_icon_black.6ea75f1c.svg";